import { render, staticRenderFns } from "./StandingsTournament.vue?vue&type=template&id=96bbb6d2&scoped=true"
import script from "./StandingsTournament.vue?vue&type=script&lang=js"
export * from "./StandingsTournament.vue?vue&type=script&lang=js"
import style0 from "./StandingsTournament.vue?vue&type=style&index=0&id=96bbb6d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bbb6d2",
  null
  
)

export default component.exports